class Storage {

  emitStorageChangedEvent() {
    const iframeEl = document.createElement("iframe");
    iframeEl.style.display = "none";
    document.body.appendChild(iframeEl);
    iframeEl.contentWindow?.localStorage.setItem("t", Date.now().toString());
    iframeEl.remove();
  }

  set(key, value) {
    localStorage.setItem(key, value);
    this.emitStorageChangedEvent();
  }

  get(key) {
    return localStorage.getItem(key) || '';
  }

  add(key, value) {
    const data = this.get(key);
    const parts = data === '' ? [] : data.split(',');
    if (parts.indexOf(value) == -1) {
      parts.push(value);
    }
    this.set(key, parts.join(','));
  }
  subtract(key, value) {
    const data = this.get(key);
    const parts = data.split(',');
    if (parts.indexOf(value) !== -1) {
      parts.splice(parts.indexOf(value));
    }
    this.set(key, parts.join(','));
  }

  toggle(key, value) {
    const data = this.get(key);
    const parts = data.split(',');
    if (parts.indexOf(value) !== -1) {
      this.subtract(key, value);
    } else {
      this.add(key, value);
    }
  }

}
const storage = new Storage();